import { XMLParser, XMLValidator } from 'fast-xml-parser';

export type ContainerFile = {
  container: {
    rootfiles: {
      rootfile: {
        '@_full-path': string;
        '@_media-type': string;
      };
    };
  };
};

export type PackageFile = {
  package: {
    metadata: {
      meta: [
        {
          '#text': string;
          '@_property': string;
        },
      ];
    };
    manifest: {
      item: [
        {
          '@_id': string;
          '@_href': string;
          '@_media-type': string;
          '@_media-overlay': string;
        },
      ];
    };
    spine?: {
      '@_page-progression-direction'?: 'ltr' | 'rtl';
    };
  };
};

export const getMediaFilesList = (file: PackageFile): string[] =>
  file.package?.manifest?.item
    ?.filter((item) => /^audio\//.test(item['@_media-type']))
    .map((item) => {
      const fNameParts = item['@_href'].split('/');
      return fNameParts[fNameParts.length - 1];
    });

export const parseEpubXml = <T>(data: string): T => {
  const result = XMLValidator.validate(data);
  if (result !== true) {
    const message = `Invalid XML structure. Error: ${JSON.stringify(result)}`;
    console.log();
    throw new Error(message);
  }
  const parser = new XMLParser({
    ignoreAttributes: false,
  });
  return parser.parse(data);
};
